import styled from "styled-components";

export const PromotionsCardContainer = styled.div`
	img {
		height: 95px;
		width: 282px;
		border-radius: 15px;
		box-shadow:
			0px 2px 20px 0px rgba(114, 0, 255, 0.5),
			0px 4px 10px 0px rgba(230, 115, 17, 0.2);

		@media (min-width: 1600px) {
			width: 350px;
			height: 120px;
		}
	}
`;
